/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  contract: { width: '15%' },
  subscribers: { width: '43%' },
  fees: { width: '15%' },
  month: { width: '15%' },
  amount: { width: '5%' },
  actions: { width: '5%' },
};

/**
 * Configuración de tamaños de fuente responsive
 */
export const FONT_SIZES = {
  header: { xs: '14px', sm: '16px' },
  tableHeader: { xs: '12px', md: '15px' },
  tableCell: { xs: '12px', md: '15px' },
  dialogTitle: { xs: '18px', md: '24px' },
  dialogContent: { xs: '14px', md: '16px' },
};

/**
 * Configuración de padding responsive
 */
export const PADDING_CONFIG = {
  header: { xs: '8px', sm: '12px' },
  dialog: { xs: '16px', sm: '24px', md: '32px' },
  tableCell: { xs: '4px', md: '8px' },
  formSection: { xs: '12px', sm: '20px', md: '25px' },
};

/**
 * Configuración de márgenes responsive
 */
export const MARGIN_CONFIG = {
  section: { xs: 1, md: 2 },
  button: { xs: 0.5, md: 1 },
  filter: { xs: 1, md: 0 },
};

/**
 * Configuración de anchos responsive para filtros
 */
export const FILTER_WIDTHS = {
  xs: '100%',
  sm: '48%',
  md: '15%',
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    SAVE_COLLECTION: '✅ Cobranza guardada exitosamente',
    CLEAR_FORM: 'Formulario limpiado exitosamente',
    CONSOLIDATE_ADDED: 'cupones consolidados agregados exitosamente',
  },
  ERROR: {
    SAVE_COLLECTION: '❌ Error al guardar la cobranza',
    CONSOLIDATE: 'Error al obtener los cupones consolidados',
    DUPLICATE_COUPON: 'Este cupón ya ha sido registrado',
    INVALID_AMOUNT: 'Debe ingresar un importe válido para el cupón de puntaje',
    NO_COUPONS: 'No hay cupones para registrar',
  },
  WARNING: {
    NEW_DUE_REQUIRED: 'Debe generar un nuevo vencimiento',
  },
  INFO: {
    NO_CONSOLIDATED: 'No se encontraron cupones consolidados para la fecha seleccionada',
  },
};

/**
 * Token y configuración AFIP (constantes del sistema)
 */
export const AFIP_CONFIG = {
  token:
    'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9InllcyI/Pgo8c3NvIHZlcnNpb249IjIuMCI+CiAgICA8aWQgc3JjPSJDTj13c2FhaG9tbywgTz1BRklQLCBDPUFSLCBTRVJJQUxOVU1CRVI9Q1VJVCAzMzY5MzQ1MDIzOSIgZHN0PSJDTj13c2ZlLCBPPUFGSVAsIEM9QVIiIHVuaXF1ZV9pZD0iMTQxNzAyMDg0NiIgZ2VuX3RpbWU9IjE3MDAyMzg4NjYiIGV4cF90aW1lPSIxNzAwMjgyMTI2Ii8+CiAgICA8b3BlcmF0aW9uIHR5cGU9ImxvZ2luIiB2YWx1ZT0iZ3JhbnRlZCI+CiAgICAgICAgPGxvZ2luIGVudGl0eT0iMzM2OTM0NTAyMzkiIHNlcnZpY2U9IndzZmUiIHVpZD0iU0VSSUFMTlVNQkVSPUNVSVQgMjAzNzYyMjgyMjQsIENOPWNvbG9uaWFsIiBhdXRobWV0aG9kPSJjbXMiIHJlZ21ldGhvZD0iMjIiPgogICAgICAgICAgICA8cmVsYXRpb25zPgogICAgICAgICAgICAgICAgPHJlbGF0aW9uIGtleT0iMjAzNzYyMjgyMjQiIHJlbHR5cGU9IjQiLz4KICAgICAgICAgICAgPC9yZWxhdGlvbnM+CiAgICAgICAgPC9sb2dpbj4KICAgIDwvb3BlcmF0aW9uPgo8L3Nzbz4K',
  sign: 'orAFUYOf8eSKu7RGVFhpSzmaM2Lv8pqJAzMTuNugfba6fBqx3nGP1wzXs8YFMqt/l3H1pYVFss9q0fBJHADweO8rFmexO5Jnqagv/AcJZ6TG4U7Kszwzmhc2xT99e8HELze0CgFdxyiAhE6Vd57w+VYAwErlq4RBXzuoecF/5jA=',
};
